import { useEffect, useMemo, useState } from '../../lib/teact/teact';

import { throttle } from '../../util/schedulers';
import windowSize from '../../util/windowSize';
import useDebouncedCallback from '../useDebouncedCallback';

const THROTTLE = 250;

export default function useWindowSize() {
  const initialSize = windowSize.get();
  const [width, setWidth] = useState(initialSize.width);
  const [height, setHeight] = useState(initialSize.height);
  const [isResizing, setIsResizing] = useState(false);
  const setIsResizingDebounced = useDebouncedCallback(setIsResizing, [setIsResizing], THROTTLE, true);

  useEffect(() => {
    const throttledSetIsResizing = throttle(() => {
      setIsResizing(true);
    }, THROTTLE, true);

    const throttledSetSize = throttle(() => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
      setIsResizingDebounced(false);
    }, THROTTLE, false);

    const handleResize = () => {
      throttledSetIsResizing();
      throttledSetSize();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [setIsResizingDebounced]);

  return useMemo(() => ({ width, height, isResizing }), [height, isResizing, width]);
}
